import { Button } from '@/shared/components';
import { NUMERIC_CONFIG } from '@/shared/config';
import { useTranslation } from 'react-i18next';
import type {
  FormStep,
  WithdrawBankTransferFormValues,
} from '@/features/withdraw-bank-transfer';
import { useForm } from 'react-hook-form';
import { WithdrawModalFooter } from '@/entities/operation';

interface WithdrawBankTransferFormProps {
  isFinalStep: boolean;
  stepData?: FormStep;
  isLoading: boolean;
  feeAmount: number;
  onSubmit: () => void;
  form: ReturnType<typeof useForm<WithdrawBankTransferFormValues>>;
  totalAmount: number;
}

export function Footer({
  isLoading,
  onSubmit,
  isFinalStep,
  stepData,
  feeAmount,
  form,
  totalAmount,
}: WithdrawBankTransferFormProps) {
  const { t } = useTranslation();

  const formIncludeFee = form.getValues('includeFee');

  return (
    <>
      {!isFinalStep && (
        <Button
          variant="default"
          className="headline4 px-[3.2rem] py-[1.6rem] rounded-[1.2rem] w-full"
          onClick={onSubmit}
          disabled={isLoading}
          loading={isLoading}>
          {t('withdrawMethods.bankTransfer.continue')}
        </Button>
      )}
      {isFinalStep && (
        <WithdrawModalFooter
          precision={NUMERIC_CONFIG.precision.default}
          amount={totalAmount}
          assetCode={stepData?.amountCurrency || ''}
          withdrawFee={feeAmount || 0}
          includeFee={formIncludeFee || false}
          disabled={isLoading}
          isLoading={isLoading}
          onSubmit={onSubmit}
          submitLabel={t('withdrawMethods.crypto.submitButton')}
        />
      )}
    </>
  );
}
